import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// primary = amarelo da Jersey (foco das caixas, seleção, paginação); o resto segue o padrão do Vuetify
export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#a87600",
      },
    },
  },
});
